import { render, staticRenderFns } from "./TagAdder.vue?vue&type=template&id=b883bec6&"
import script from "./TagAdder.vue?vue&type=script&lang=js&"
export * from "./TagAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports